export const INTERNAL_EMAIL_DOMAIN = '@productscience.ai'

export const isUserProductScience = (email: string) => email.includes(INTERNAL_EMAIL_DOMAIN)

export const isFlowHidden = (hidden?: boolean | null, email: string | undefined = '') =>
  !!hidden && !isUserProductScience(email)
